import React from 'react';

class ListItemThongKeGQDTC extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {

    }
  }

  render() {
    let Item = this.props.item || {};
    return (
      <tr className={this.props.sum ? 'txt-bold' : ''}>
        <td className='column-stt-fixed'>{this.props.count}</td>
        <td className='column-name-fixed'>{Item.donVi ? Item.donVi.ten : (Item.capDonVi ? Item.capDonVi.ten : '')}</td>

        <td className='txt-center'>{Item.tongSoDonToCao ? Item.tongSoDonToCao : 0}</td>
        <td className='txt-center'>{Item.donNhanTrongKyBaoCao ? Item.donNhanTrongKyBaoCao : 0}</td>
        <td className='txt-center'>{Item.donTonKyTruocChuyenSang ? Item.donTonKyTruocChuyenSang : 0}</td>
        <td className='txt-center'>{Item.tongSoVuViec ? Item.tongSoVuViec : 0}</td>

        <td className='txt-center'>{Item.soDonThuocThamQuyen ? Item.soDonThuocThamQuyen : 0}</td>
        <td className='txt-center'>{Item.soVuViecThuocThamQuyen ? Item.soVuViecThuocThamQuyen : 0}</td>

        <td className='txt-center'>{Item.toCaoDung ? Item.toCaoDung : 0}</td>
        <td className='txt-center'>{Item.toCaoSai ? Item.toCaoSai : 0}</td>
        <td className='txt-center'>{Item.toCaoDungMotPhan ? Item.toCaoDungMotPhan : 0}</td>

        <td className='txt-right'>{Item.kienNghiThuHoiChoNhaNuocTien ? Item.kienNghiThuHoiChoNhaNuocTien : 0}</td>
        <td className='txt-right'>{Item.kienNghiThuHoiChoNhaNuocDat ? Item.kienNghiThuHoiChoNhaNuocDat : 0}</td>
        <td className='txt-right'>{Item.traLaiChoCongDanTien ? Item.traLaiChoCongDanTien : 0}</td>
        <td className='txt-right'>{Item.traLaiChoCongDanDat ? Item.traLaiChoCongDanDat : 0}</td>

        <td className='txt-center'>{Item.soNguoiDuocTraLaiQuyenLoi ? Item.soNguoiDuocTraLaiQuyenLoi : 0}</td>

        <td className='txt-center'>{Item.kienNghiXuLyHanhChinhTongSoNguoi ? Item.kienNghiXuLyHanhChinhTongSoNguoi : 0}</td>
        <td className='txt-center'>{Item.kienNghiXuLyHanhChinhSoNguoiDaBiXuLy ? Item.kienNghiXuLyHanhChinhSoNguoiDaBiXuLy : 0}</td>

        <td className='txt-center'>{Item.soVuChuyenCoQuanDieuTra ? Item.soVuChuyenCoQuanDieuTra : 0}</td>
        <td className='txt-center'>{Item.soDoiTuongChuyenCoQuanDieuTra ? Item.soDoiTuongChuyenCoQuanDieuTra : 0}</td>

        <td className='txt-center'>{Item.soVuDaKhoiTo ? Item.soVuDaKhoiTo : 0}</td>
        <td className='txt-center'>{Item.soDoiTuongDaKhoiTo ? Item.soDoiTuongDaKhoiTo : 0}</td>

        <td className='txt-center'>{Item.soVuViecGiaiQuyetDungThoiHan ? Item.soVuViecGiaiQuyetDungThoiHan : 0}</td>
        <td className='txt-center'>{Item.soVuViecGiaiQuyetQuaThoiHan ? Item.soVuViecGiaiQuyetQuaThoiHan : 0}</td>

        <td className='txt-center'>{Item.tongSoQuyetDinhPhaiToChucThucHien ? Item.tongSoQuyetDinhPhaiToChucThucHien : 0}</td>
        <td className='txt-center'>{Item.tongSoQuyetDinhPhaiToChucThucHienDaThucHien ? Item.tongSoQuyetDinhPhaiToChucThucHienDaThucHien : 0}</td>

        <td className='txt-right'>{Item.tienPhaiThuChoNhaNuoc ? Item.tienPhaiThuChoNhaNuoc : 0}</td>
        <td className='txt-right'>{Item.datPhaiThuChoNhaNuoc ? Item.datPhaiThuChoNhaNuoc : 0}</td>
        <td className='txt-right'>{Item.tienDaThuChoNhaNuoc ? Item.tienDaThuChoNhaNuoc : 0}</td>
        <td className='txt-right'>{Item.datDaThuChoNhaNuoc ? Item.datDaThuChoNhaNuoc : 0}</td>

        <td className='txt-right'>{Item.tienPhaiTraChoCongDan ? Item.tienPhaiTraChoCongDan : 0}</td>
        <td className='txt-right'>{Item.datPhaiTraChoCongDan ? Item.datPhaiTraChoCongDan : 0}</td>
        <td className='txt-right'>{Item.tienDaTraChoCongDan ? Item.tienDaTraChoCongDan : 0}</td>
        <td className='txt-right'>{Item.datDaTraChoCongDan ? Item.datDaTraChoCongDan : 0}</td>

        <td className='ghi-chu'>{Item.ghiChu ? Item.ghiChu : ''}</td>
      </tr>
    );
  }
}

export default ListItemThongKeGQDTC;


// WEBPACK FOOTER //
// ./src/components/modules/thong-ke-bao-cao/datatable/ListItemThongKeGQDTC.jsx